import { postRequest } from './methods/postRequest';
import { requestToJSON } from './methods/requestToJSON';

export const createShortUrl = (url: string) =>
  requestToJSON<{ link: string }>(postRequest('https://sprd.co/api/links', { to: url })).then(
    ({ link }) => link
  );
